import type { BaseKeyFunction } from "../../../../lib";

export type KeyCommunityUserProps = {
  id: number;
};

export const keyCommunityUser: BaseKeyFunction<KeyCommunityUserProps> = ({
  id,
}) => ["community-users", id.toString()];
